import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

export type Props = {
  color?: 'green';
  inline?: boolean;
  left?: number;
};

export const Badge: React.FC<Props> = ({
  children,
  color,
  inline,
  left = 0,
}) => (
  <div
    className={cx(
      styles.root,
      color && styles[`color-${color}`],
      inline && styles.inline
    )}
    style={{
      marginLeft: left,
    }}
  >
    {children}
  </div>
);
